import React, { Dispatch, ReactNode, useMemo, useReducer } from "react";
import { Group } from "types/Models/group";
import { initialGroupState } from "contexts/CurrentGroupContext";

type CurrentChatGroupAction = {
  type: "SET_GROUP";
  payload: Partial<Group>;
};

export type CurrentChatGroupContextT = Group & {
  dispatch: Dispatch<CurrentChatGroupAction>;
};

export const CurrentChatGroupContext =
  React.createContext<CurrentChatGroupContextT>(
    initialGroupState as CurrentChatGroupContextT
  );

export const CurrentChatGroupContextProvider = ({
  children,
}: {
  children: ReactNode;
}): React.JSX.Element => {
  const reducer = (state: Group, action: CurrentChatGroupAction) => {
    switch (action.type) {
      case "SET_GROUP":
        return { ...state, ...action.payload };

      default:
        return { ...state };
    }
  };
  const [state, dispatch] = useReducer(reducer, initialGroupState);

  const contextValue = useMemo(
    () => ({ ...state, dispatch }),
    [JSON.stringify(state), dispatch]
  );

  return (
    <CurrentChatGroupContext.Provider value={contextValue}>
      {children}
    </CurrentChatGroupContext.Provider>
  );
};
